import { customer } from '@icabbi/api-gateway-client';
import { Authentication } from '@icabbi/vue-authentication';

const defaultState = {
  payoutsQueryClient: null,
};

const getters = {
  // eslint-disable-next-line no-shadow
  payoutsQueryClient: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (state.payoutsQueryClient === null) {
      const authentication = Authentication({ dispatch, getters: rootGetters });
      const { authenticationFailureInterceptor, bearerTokenInterceptor } = authentication;
      const payoutsQueryClient = new customer.ChargeQueryConnector({
        baseURL: process.env.VUE_APP_API_GATEWAY_URL,
        timeout: parseInt('99999', 10),
      });
      payoutsQueryClient.httpClient.interceptors.response.use(undefined, error => authenticationFailureInterceptor(error));
      payoutsQueryClient.httpClient.interceptors.request.use(config => bearerTokenInterceptor(config));
      state.payoutsQueryClient = payoutsQueryClient;
    }
    return state.payoutsQueryClient;
  },
};

const actions = {

  async listPayouts(context, {
    page, maxPerPage, sort, statusAtStart, statusAtEnd, status,
  }) {
    try {
      const params = {
        sort, page, maxPerPage, status, statusAtStart, statusAtEnd, timezone: 'local',
      };

      const payoutsQueryClient = context.getters.payoutsQueryClient(context);
      const payouts = await payoutsQueryClient.listPayouts(params);
      return payouts;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'payouts.getPayoutsError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },

  async listChargesForPayout(context, {
    page, maxPerPage, sort, payoutId,
  }) {
    try {
      const params = {
        sort, page, maxPerPage, payoutId, timezone: 'local',
      };

      const payoutsQueryClient = context.getters.payoutsQueryClient(context);
      const charges = await payoutsQueryClient.listCharges(params);
      return charges;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'charges.getChargesError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },
};

const mutations = {};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
